import { UnlockIcon, LockIcon } from "../../icons/icons";

export default class DragResizeTune {
  static get isTune() {
    return true;
  }

  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;
    this.data = data || {
      draggable: {
        absolute: true,
        width: "",
        height: "",
        top: "",
        left: "",
        locked: false,
      },
    };
    this.locked = data?.draggable.locked || false;
    this.draggableWrapper = null;
    this.readOnly = this.api.readOnly?.isEnabled;
  }

  wrap(blockContent) {
    const draggableWrapper = document.createElement("div");
    const controlWrapper = document.createElement("div");
    const draggableContent = document.createElement("div");

    if (this.locked || this.readOnly) {
      draggableWrapper.classList.add("locked");
    }

    this.draggableWrapper = draggableWrapper;

    draggableWrapper.classList.add("draggable-wrapper");
    controlWrapper.classList.add("draggable-controls");
    draggableContent.classList.add("draggable-content");

    const dragElement = document.createElement("div");
    const rightWidthElement = document.createElement("div");
    const leftWidthElement = document.createElement("div");
    const bottomHeightElement = document.createElement("div");
    const topHeightElement = document.createElement("div");

    const topLeftElement = document.createElement("div");
    const topRightElement = document.createElement("div");
    const bottomRightElement = document.createElement("div");
    const bottomLeftElement = document.createElement("div");

    const topTooltip = document.createElement("div");
    const leftTooltip = document.createElement("div");
    const bottomTooltip = document.createElement("div");
    const rightTooltip = document.createElement("div");

    let isDragging = false;
    let isRightWidthResize = false;
    let isLeftWidthResize = false;
    let isBottomHeightResize = false;
    let isTopHeightResize = false;
    let startX, startY;
    let offsetX, offsetY;
    let height, width;
    let target;
    let absolute = false;
    let modified = false;
    let snapToGrid = false;
    let lockAspectRatio = false;
    let aspectRatio = 0;
    let dragTimer = null;
    const gridSize = 5;

    dragElement.classList.add("block-drag-handle");
    leftWidthElement.classList.add(
      "block-resize-width-handle-left",
      "edge-handle"
    );
    rightWidthElement.classList.add(
      "block-resize-width-handle-right",
      "edge-handle"
    );
    topHeightElement.classList.add(
      "block-resize-height-handle-top",
      "edge-handle"
    );
    bottomHeightElement.classList.add(
      "block-resize-height-handle-bottom",
      "edge-handle"
    );

    topLeftElement.classList.add(
      "block-resize-top-left-handle",
      "corner-handle"
    );
    topRightElement.classList.add(
      "block-resize-top-right-handle",
      "corner-handle"
    );
    bottomRightElement.classList.add(
      "block-resize-bottom-right-handle",
      "corner-handle"
    );
    bottomLeftElement.classList.add(
      "block-resize-bottom-left-handle",
      "corner-handle"
    );

    topTooltip.classList.add("block-drag-tooltip", "top-tooltip");
    leftTooltip.classList.add("block-drag-tooltip", "left-tooltip");
    bottomTooltip.classList.add("block-drag-tooltip", "right-tooltip");
    rightTooltip.classList.add("block-drag-tooltip", "bottom-tooltip");

    dragElement.setAttribute("contenteditable", "false");
    leftWidthElement.setAttribute("contenteditable", "false");
    rightWidthElement.setAttribute("contenteditable", "false");
    topHeightElement.setAttribute("contenteditable", "false");
    bottomHeightElement.setAttribute("contenteditable", "false");
    topLeftElement.setAttribute("contenteditable", "false");
    topRightElement.setAttribute("contenteditable", "false");
    bottomRightElement.setAttribute("contenteditable", "false");
    bottomLeftElement.setAttribute("contenteditable", "false");
    topTooltip.setAttribute("contenteditable", "false");
    leftTooltip.setAttribute("contenteditable", "false");
    bottomTooltip.setAttribute("contenteditable", "false");
    rightTooltip.setAttribute("contenteditable", "false");

    dragElement.innerHTML =
      // '<svg class="block-drag-handle-svg" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M480-80 310-250l57-57 73 73v-206H235l73 72-58 58L80-480l169-169 57 57-72 72h206v-206l-73 73-57-57 170-170 170 170-57 57-73-73v206h205l-73-72 58-58 170 170-170 170-57-57 73-73H520v205l72-73 58 58L480-80Z"/></svg>';
      '<svg class="block-drag-handle-svg" width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"> <path d="m476.51 214.01 85.988-85.969v284.46c0 20.699 16.781 37.5 37.5 37.5 20.699 0 37.5-16.801 37.5-37.5v-284.46l85.988 85.969c7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988c14.645-14.645 14.645-38.383 0-53.023l-150-150c-14.645-14.645-38.383-14.645-53.023 0l-150 150c-14.645 14.645-14.645 38.383 0 53.023 14.645 14.645 38.379 14.645 53.023 0z" fill="#1c9bf1"/> <path d="m723.49 985.99-85.988 85.969v-284.46c0-20.699-16.801-37.5-37.5-37.5-20.719 0-37.5 16.801-37.5 37.5v284.46l-85.988-85.969c-14.645-14.645-38.383-14.645-53.023 0-14.645 14.645-14.645 38.383 0 53.023l150 150c7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988l150-150c14.645-14.645 14.645-38.383 0-53.023-14.645-14.645-38.379-14.645-53.023 0z" fill="#1c9bf1"/> <path d="m128.02 637.5h284.48c20.699 0 37.5-16.801 37.5-37.5s-16.801-37.5-37.5-37.5h-284.48l85.988-85.988c14.645-14.645 14.645-38.383 0-53.023-14.645-14.645-38.383-14.645-53.023 0l-150 150c-14.645 14.645-14.645 38.383 0 53.023l150 150c7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988c14.645-14.645 14.645-38.383 0-53.023z" fill="#1c9bf1"/> <path d="m1189 573.49-150-150c-14.645-14.645-38.383-14.645-53.023 0-14.645 14.645-14.645 38.383 0 53.023l85.988 85.988h-284.48c-20.719 0-37.5 16.801-37.5 37.5s16.781 37.5 37.5 37.5h284.48l-85.988 85.988c-14.645 14.645-14.645 38.383 0 53.023 7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988l150-150c14.645-14.645 14.645-38.379 0-53.023z" fill="#1c9bf1"/> <path d="m573.56 573.56c-7.125 6.9375-11.062 16.5-11.062 26.438s3.9375 19.5 11.062 26.438c6.9375 7.125 16.5 11.062 26.438 11.062s19.5-3.9375 26.438-11.062c7.125-6.9375 11.062-16.5 11.062-26.438 0-9.75-3.9375-19.5-11.062-26.438-13.875-14.062-39-14.062-52.875 0z" fill="#1c9bf1"/> </svg>';

    draggableContent.setAttribute("tabindex", "0");

    //For external size modification
    const debounce = (func, timeout = 1000) => {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    };

    // Helper function to calculate current aspect ratio
    const calculateAspectRatio = () => {
      return target.offsetWidth / target.offsetHeight;
    };

    // Global keyboard event handlers for aspect ratio and grid snapping
    const globalKeyDown = (e) => {
      if (e.key === "Alt") {
        if (!snapToGrid) {
          snapToGrid = true;
          handleGrid(true);
        }
      }
      if (e.key === "Shift" || e.key === "shift") {
        if (!lockAspectRatio && target) {
          lockAspectRatio = true;
          // Calculate aspect ratio immediately when shift is pressed
          aspectRatio = calculateAspectRatio();
        }
      }
    };

    const globalKeyUp = (e) => {
      if (e.key === "Alt") {
        if (snapToGrid) {
          snapToGrid = false;
          handleGrid(false);
        }
        clearTooltips();
      }

      if (e.key === "Shift" || e.key === "shift") {
        if (lockAspectRatio) {
          lockAspectRatio = false;
          aspectRatio = 0;
        }
        clearTooltips();
      }
    };

    // Set position and dimensions on load
    requestAnimationFrame(() => {
      target = draggableWrapper.closest(".ce-block");

      if (this.data.draggable) {
        if (target) {
          let style = { ...this.data.draggable };
          if (style.absolute) {
            absolute = true;
            target.style.position = "absolute";
            target.style.top = style.top;
            target.style.left = style.left;
          }
          if (style.width) {
            target.style.width = `${style.width}px`;
          }
          if (style.height) {
            target.style.height = `${style.height}px`;
          }
        }
      }

      // Add global keyboard listeners
      document.addEventListener("keydown", globalKeyDown);
      document.addEventListener("keyup", globalKeyUp);
    });

    dragElement.addEventListener("mousedown", dragMouseDown);
    dragElement.addEventListener(
      "touchstart",
      (e) => {
        const touch = e.touches[0];
        dragMouseDown({
          ...e,
          clientX: touch.clientX,
          clientY: touch.clientY,
        });
      },
      { passive: false }
    );

    function dragMouseDown(e) {
      e.stopPropagation();
      isDragging = true;
      setDimensions();
      setPositions(e);
      addDocumentListeners();
    }

    rightWidthElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isRightWidthResize = true;
      addDocumentListeners();
    });

    leftWidthElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isLeftWidthResize = true;
      addDocumentListeners();
    });

    topHeightElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isTopHeightResize = true;
      addDocumentListeners();
    });

    bottomHeightElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isBottomHeightResize = true;
      addDocumentListeners();
    });

    topLeftElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isLeftWidthResize = true;
      isTopHeightResize = true;
      addDocumentListeners();
    });

    topRightElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isTopHeightResize = true;
      isRightWidthResize = true;
      addDocumentListeners();
    });

    bottomRightElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isRightWidthResize = true;
      isBottomHeightResize = true;
      addDocumentListeners();
    });

    bottomLeftElement.addEventListener("mousedown", (e) => {
      e.stopPropagation();
      setDimensions();
      setPositions(e);
      isLeftWidthResize = true;
      isBottomHeightResize = true;
      addDocumentListeners();
    });

    // Mouse move operations
    const mouseMove = (e) => {
      modified = true;
      let tooltipTopValue = startY - offsetY;
      let tooltipLeftValue = startX - offsetX;
      let tooltipWidthValue = null;
      let tooltipHeightValue = null;
      if (isDragging) {
        // dragTimer = setTimeout(() => {
        let leftValue = snapToGrid
          ? Math.round((e.clientX - offsetX) / gridSize) * gridSize
          : e.clientX - offsetX;
        let topValue = snapToGrid
          ? Math.round((e.clientY - offsetY) / gridSize) * gridSize
          : e.clientY - offsetY;
        absolute = true;
        target.style.position = "absolute";
        target.style.width = `${width}px`;
        target.style.height = `${height}px`;
        target.style.left = `${leftValue}px`;
        target.style.top = `${topValue}px`;
        tooltipTopValue = topValue;
        tooltipLeftValue = leftValue;
        tooltipWidthValue = width;
        tooltipHeightValue = height;
      }
      if (isRightWidthResize) {
        let widthValue = snapToGrid
          ? Math.round((width + (e.clientX - startX)) / gridSize) * gridSize
          : width + (e.clientX - startX);
        if (lockAspectRatio) {
          let newHeight = widthValue / aspectRatio;
          if (!isBottomHeightResize && !isTopHeightResize) {
            target.style.height = `${newHeight}px`;
            target.style.top = `${
              startY - offsetY - (newHeight - height) / 2
            }px`;
            target.style.width = `${widthValue}px`;
            tooltipHeightValue = newHeight;
            tooltipTopValue = parseInt(startY - offsetY - (newHeight - height) / 2);
            tooltipWidthValue = widthValue;
          }
        } else {
          target.style.width = `${widthValue}px`;
          tooltipWidthValue = widthValue;
        }
      }
      if (isLeftWidthResize) {
        let widthValue = snapToGrid
          ? Math.round((width - (e.clientX - startX)) / gridSize) * gridSize
          : width - (e.clientX - startX);
        let leftValue = snapToGrid
          ? Math.round((e.clientX - offsetX) / gridSize) * gridSize
          : e.clientX - offsetX;

        absolute = true;
        target.style.position = "absolute";

        if (lockAspectRatio) {
          let newHeight = widthValue / aspectRatio;
          let newTop = startY - offsetY - (newHeight - height) / 2;

          if (!isTopHeightResize && !isBottomHeightResize) {
            target.style.height = `${newHeight}px`;
            target.style.top = `${newTop}px`;
            target.style.left = `${leftValue}px`;
            target.style.width = `${widthValue}px`;

            tooltipHeightValue = newHeight;
            tooltipTopValue = parseInt(newTop);
            tooltipLeftValue = leftValue;
            tooltipWidthValue = widthValue;
          }
        } else {
          target.style.left = `${leftValue}px`;
          target.style.width = `${widthValue}px`;

          tooltipWidthValue = widthValue;
          tooltipLeftValue = leftValue;
        }
      }
      if (isBottomHeightResize) {
        let heightValue = snapToGrid
          ? Math.round((height + (e.clientY - startY)) / gridSize) * gridSize
          : height + (e.clientY - startY);
        target.style.height = `${heightValue}px`;

        tooltipHeightValue = heightValue;
        if (lockAspectRatio) {
          let newWidth = heightValue * aspectRatio;
          let leftValue;
          if (isLeftWidthResize) {
            leftValue = startX - offsetX + (width - newWidth);
            target.style.left = `${leftValue}px`;

            tooltipLeftValue = leftValue;
          }

          if (!isLeftWidthResize && !isRightWidthResize) {
            leftValue = startX - offsetX + (width - newWidth) / 2;
            target.style.left = `${leftValue}px`;

            tooltipLeftValue = leftValue;
          }

          target.style.width = `${newWidth}px`;

          tooltipWidthValue = newWidth;
        }
      }
      if (isTopHeightResize) {
        let heightValue = snapToGrid
          ? Math.round((height - (e.clientY - startY)) / gridSize) * gridSize
          : height - (e.clientY - startY);
        let topValue = snapToGrid
          ? Math.round((e.clientY - offsetY) / gridSize) * gridSize
          : e.clientY - offsetY;

        absolute = true;
        target.style.position = "absolute";
        target.style.height = `${heightValue}px`;
        target.style.top = `${topValue}px`;

        tooltipHeightValue = heightValue;
        tooltipTopValue = topValue;

        if (lockAspectRatio) {
          let newWidth = heightValue * aspectRatio;
          let leftValue;
          // top right
          if (isRightWidthResize) {
          }

          // top left
          if (isLeftWidthResize) {
            leftValue = startX - offsetX + (width - newWidth);
            target.style.left = `${leftValue}px`;

            tooltipLeftValue = leftValue;
          }
          // top center
          if (!isLeftWidthResize && !isRightWidthResize) {
            leftValue = startX - offsetX + (width - newWidth) / 2;
            target.style.left = `${leftValue}px`;

            tooltipLeftValue = leftValue;
          }

          target.style.width = `${newWidth}px`;

          tooltipWidthValue = newWidth;
        }
      }

      displayTooltips(
        parseInt(tooltipTopValue), 
        parseInt(tooltipLeftValue), 
        tooltipWidthValue ? parseInt(tooltipWidthValue) : null, 
        tooltipHeightValue ? parseInt(tooltipHeightValue) : null);

      const event = new CustomEvent("block-drag-move", {
        detail: {
          blockId: this.block.id,
        },
      });
      window.dispatchEvent(event);
      initSave();
    };
    // Listener cleanup
    const mouseUp = (e) => {
      if (isDragging && checkDelta(e)) {
        dragHide();
      }
      clearTimeout(dragTimer);
      isDragging = false;
      isRightWidthResize = false;
      isLeftWidthResize = false;
      isBottomHeightResize = false;
      isTopHeightResize = false;
      snapToGrid = false;
      lockAspectRatio = false;
      aspectRatio = 0;
      document.removeEventListener("mousemove", mouseMove);
      document.removeEventListener("mouseup", mouseUp);
      handleGrid(false);
      clearTooltips();
      initSave();
    };

    const dragHide = () => {
      target = draggableWrapper.closest(".ce-block");
      isDragging = false;
      if (target) {
        // dragHandle.style.display = 'none';
        target.setAttribute("tabindex", "0");
        target.classList.add("hide-drag-handle");
        let contentEditableTag = draggableContent.querySelector(
          '[contenteditable="true"'
        );
        if (contentEditableTag) {
          contentEditableTag.focus();
        } else {
          target.focus();
        }

        target.addEventListener("focusout", handleFocusOut);
      }
    };

    const handleFocusOut = (event) => {
      if (!target.contains(event.relatedTarget)) {
        target.classList.remove("hide-drag-handle");
        target.removeEventListener("focusout", handleFocusOut);
      }
    };

    const checkDelta = (e) => {
      const delta = 6;
      if (startX && startY && e) {
        const diffX = Math.abs(e.clientX - startX);
        const diffY = Math.abs(e.clientY - startY);
        if (diffX < delta && diffY < delta) {
          return true;
        } else return false;
      }
    };

    const setDimensions = () => {
      width = target.offsetWidth;
      height = target.offsetHeight;
    };

    const setPositions = (e) => {
      startX = e.clientX;
      startY = e.clientY;
      offsetX = e.clientX - target.offsetLeft;
      offsetY = e.clientY - target.offsetTop;
    };

    const addDocumentListeners = () => {
      if (!this.locked && !this.readOnly) {
        document.addEventListener("mousemove", mouseMove);
        document.addEventListener("mouseup", mouseUp);
      }
    };

    const displayTooltips = (top, left, width, height) => {
      if (top !== undefined && top !== null) {
        topTooltip.innerText = `Y: ${top}`;
        if (!topTooltip.classList.contains("show")) {
          topTooltip.classList.add("show");
        }
        if (top < 40) {
          if (!topTooltip.classList.contains("inner")) {
            topTooltip.classList.add("inner");
          }
        } else {
          if (topTooltip.classList.contains("inner")) {
            topTooltip.classList.remove("inner");
          }
        }
      }

      if (left !== undefined && left !== null) {
        leftTooltip.innerText = `X: ${left}`;
        if (!leftTooltip.classList.contains("show")) {
          leftTooltip.classList.add("show");
        }
        if (top < 40) {
          if (!leftTooltip.classList.contains("inner")) {
            leftTooltip.classList.add("inner");
          }
        } else {
          if (leftTooltip.classList.contains("inner")) {
            leftTooltip.classList.remove("inner");
          }
        }
      }

      if (width !== undefined && width !== null) {
        rightTooltip.innerText = `W: ${width}`;
        if (!rightTooltip.classList.contains("show")) {
          rightTooltip.classList.add("show");
        }
        if (left + width > 1291) {
          if (!rightTooltip.classList.contains("inner")) {
            rightTooltip.classList.add("inner");
          }
        } else {
          if (rightTooltip.classList.contains("inner")) {
            rightTooltip.classList.remove("inner");
          }
        }
      }

      if (height !== undefined && height !== null) {
        bottomTooltip.innerText = `H: ${height}`;
        if (!bottomTooltip.classList.contains("show")) {
          bottomTooltip.classList.add("show");
        }
        if (top + height > 728) {
          if (!bottomTooltip.classList.contains("inner")) {
            bottomTooltip.classList.add("inner");
          }
        } else {
          if (bottomTooltip.classList.contains("inner")) {
            bottomTooltip.classList.remove("inner");
          }
        }
      }
    };

    const clearTooltips = () => {
      if (topTooltip.classList.contains("show")) {
        topTooltip.classList.remove("show");
      }
      if (leftTooltip.classList.contains("show")) {
        leftTooltip.classList.remove("show");
      }
      if (rightTooltip.classList.contains("show")) {
        rightTooltip.classList.remove("show");
      }
      if (bottomTooltip.classList.contains("show")) {
        bottomTooltip.classList.remove("show");
      }
      topTooltip.innerText = "";
      leftTooltip.innerText = "";
      rightTooltip.innerText = "";
      bottomTooltip.innerText = "";
    };

    const handleGrid = (_snapToGrid) => {
      let innerContainer = draggableWrapper.closest(".inner-container");
      if (innerContainer) {
        if (_snapToGrid) {
          if (!innerContainer.classList.contains("grid")) {
            innerContainer.classList.add("grid");
          }
        } else {
          if (innerContainer.classList.contains("grid")) {
            innerContainer.classList.remove("grid");
          }
        }
      }
    };

    const initSave = debounce(() => {
      if (modified && !this.readOnly) {
        this.data.draggable = {
          absolute: absolute,
          width: target.offsetWidth,
          height: target.offsetHeight,
          top: target.style.top,
          left: target.style.left,
          locked: this.locked,
        };
        modified = false;
        this.block.dispatchChange();
      }
    });

    controlWrapper.appendChild(dragElement);
    controlWrapper.appendChild(leftWidthElement);
    controlWrapper.appendChild(rightWidthElement);
    controlWrapper.appendChild(topHeightElement);
    controlWrapper.appendChild(bottomHeightElement);
    controlWrapper.appendChild(topLeftElement);
    controlWrapper.appendChild(topRightElement);
    controlWrapper.appendChild(bottomRightElement);
    controlWrapper.appendChild(bottomLeftElement);
    draggableContent.append(blockContent);
    draggableWrapper.append(draggableContent);
    draggableWrapper.append(controlWrapper);

    draggableWrapper.append(topTooltip);
    draggableWrapper.append(leftTooltip);
    draggableWrapper.append(rightTooltip);
    draggableWrapper.append(bottomTooltip);

    return draggableWrapper;
  }

  lockSwitch(_locked) {
    if (_locked) {
      if (this.draggableWrapper) {
        if (!this.draggableWrapper.classList.contains("locked")) {
          this.draggableWrapper.classList.add("locked");
        }
      }
      return {
        icon: LockIcon,
        label: "Unlock",
      };
    } else {
      if (this.draggableWrapper) {
        if (this.draggableWrapper.classList.contains("locked")) {
          this.draggableWrapper.classList.remove("locked");
        }
      }
      return {
        icon: UnlockIcon,
        label: "Lock",
      };
    }
  }

  renderLockBtn() {
    const lockBtnContainer = document.createElement("button");
    const lockBtnIcon = document.createElement("div");
    const lockBtnLabel = document.createElement("div");

    lockBtnContainer.classList.add("cdx-draggable-lock-btn-container");
    lockBtnIcon.classList.add("cdx-draggable-lock-btn-icon");
    lockBtnLabel.classList.add("cdx-draggable-lock-btn-label");

    lockBtnIcon.innerHTML = this.lockSwitch(this.locked).icon;
    lockBtnLabel.innerHTML = this.lockSwitch(this.locked).label;

    lockBtnContainer.appendChild(lockBtnIcon);
    lockBtnContainer.appendChild(lockBtnLabel);

    lockBtnContainer.addEventListener("click", () => {
      this.locked = !this.locked;
      lockBtnIcon.innerHTML = this.lockSwitch(this.locked).icon;
      lockBtnLabel.innerHTML = this.lockSwitch(this.locked).label;
      this.data.draggable.locked = this.locked;
      // this.block.dispatchChange();
    });

    return lockBtnContainer;
  }

  render() {
    const draggableSettings = document.createElement("div");
    const settingsLabel = document.createElement("label");
    draggableSettings.classList.add(
      "draggable-lock-tune",
      "editor-block-tune"
    );
    settingsLabel.classList.add("editor-block-tune-title");
    settingsLabel.innerText = "Draggable";

    draggableSettings.appendChild(settingsLabel);
    draggableSettings.appendChild(this.renderLockBtn());

    const index = this.api.blocks.getCurrentBlockIndex();

    this.api.blocks.setDraggable(index, true);

    return draggableSettings;
  }

  save() {
    return this.data;
  }
}
